export const getJson = (url) => new Promise((res, rej) => {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', url);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.onload = () => {
        if (xhr.status === 200) {
            try {
                res(JSON.parse(xhr.responseText));
            }
            catch (e) {
                rej(e);
            }
        }
        else if (xhr.status !== 200) {
            rej({
                status: xhr.status,
                statusText: xhr.responseText,
            });
        }
    };
    xhr.send();
});
//# sourceMappingURL=rest.js.map